import React from 'react'

import { CSSTransition } from 'react-transition-group'

import styles from './Backdrop.module.scss'

export const Backdrop = ({ children, timeout = 3600000, isVisible }) => {
  const ref = React.useRef()

  return (
    <CSSTransition
      className={styles.backdrop}
      classNames={{
        appear: styles.appear,
        appearActive: styles.appearActive,
        enter: styles.enter,
        enterActive: styles.enterActive,
        exit: styles.exit,
        exitActive: styles.exitActive,
      }}
      nodeRef={ref}
      timeout={timeout}
      in={isVisible}
      appear
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.backdrop} {...{ ref }}>
        {children}
      </div>
    </CSSTransition>
  )
}
